<template>
  <v-container v-if="hasSettings && !hasProducts" transition="fade-transition" class="px-0 ml-0">
    <v-card class="sigfloCard elevation-0 pa-12" max-width="1114">
      <div class="helpButton d-flex">
        <sig-help-menu-button logo-side="right" :sigfloMessages="sigfloMessages" />
      </div>
      <v-form ref="settingsForm" submit-prevent>
        <!-- <div class="requiredAsterisk mt-0 pt-0">* Required</div> -->
        <v-row class="pt-4">
          <v-col
            class="settingColumn"
            v-for="setting in configurator.currentSubsystemStepComponent.componentSettingModels"
            :key="setting.componentSettingDefinitionId"
          >
            <div class="settingLabel">
              <v-btn rounded class="elevation-0 text-capitalize sigfloBody600" color="#F4F2F7">{{
                setting.label
              }}</v-btn>
              <!-- <div class="requiredAsterisk" v-if="setting.required">*</div> -->
            </div>

            <div class="settingInput ma-0 pb-0 pl-2 mt-4">
              <div v-if="setting.controlType.toLowerCase() === 'int'">
                <v-text-field
                  outlined
                  single-line
                  persistent-hint
                  v-model="setting.value"
                  :rules="getNumericRules(setting)"
                  :suffix="setting.valueSuffix"
                  :label="setting.label"
                  value=""
                  :hint="setting.description"
                  :ref="'setting' + setting.componentSettingDefinitionId"
                  @change="
                    updateComponentSettingModel('setting' + setting.componentSettingDefinitionId, $event, setting)
                  "
                  ><template v-slot:append v-if="setting.required && !setting.value">
                    <v-icon color="red">mdi-alert</v-icon>
                  </template></v-text-field
                >
              </div>
              <div v-if="setting.controlType.toLowerCase() === 'multidecimal'">
                <v-text-field
                  outlined
                  single-line
                  persistent-hint
                  v-model="setting.value"
                  :rules="getNumericRules(setting)"
                  :suffix="setting.valueSuffix"
                  :label="setting.name"
                  value=""
                  :hint="setting.description"
                  :ref="'setting' + setting.componentSettingDefinitionId"
                  @change="
                    updateComponentSettingModel('setting' + setting.componentSettingDefinitionId, $event, setting)
                  "
                  ><template v-slot:append v-if="setting.required && !setting.value">
                    <v-icon color="red">mdi-alert</v-icon>
                  </template></v-text-field
                >
              </div>
              <div v-if="setting.controlType.toLowerCase() === 'yesno'">
                <v-checkbox
                  v-model="setting.value"
                  :ref="'setting' + setting.componentSettingDefinitionId"
                  @change="
                    updateComponentSettingModel('setting' + setting.componentSettingDefinitionId, $event, setting)
                  "
                ></v-checkbox>
              </div>
              <div v-if="setting.controlType.toLowerCase() === 'dropdownlist'">
                <v-select
                  outlined
                  single-line
                  :rules="setting.required ? validation.selection : []"
                  v-model="setting.value"
                  persistent-hint
                  :hint="setting.description"
                  :items="getComponentSettingValueModels(setting)"
                  item-text="label"
                  item-value="value"
                  :label="setting.name"
                  :ref="'setting' + setting.componentSettingDefinitionId"
                  @change="
                    updateComponentSettingModel('setting' + setting.componentSettingDefinitionId, $event, setting)
                  "
                  ><template v-slot:append v-if="setting.required && !setting.value">
                    <v-icon color="red">mdi-alert</v-icon>
                  </template></v-select
                >
              </div>
              <div v-if="setting.controlType.toLowerCase() === 'multiselect'">
                <v-select
                  :rules="setting.required ? validation.selection : []"
                  :value="setting.value ? setting.value.split(',') : null"
                  :items="setting.componentSettingValueModels"
                  outlined
                  single-line
                  attach
                  chips
                  label="Values"
                  :hint="setting.description"
                  multiple
                  item-text="label"
                  item-value="value"
                  deletable-chips
                  :ref="'setting' + setting.componentSettingDefinitionId"
                  @change="
                    updateComponentSettingModel('setting' + setting.componentSettingDefinitionId, $event, setting)
                  "
                  ><template v-slot:append v-if="setting.required && !setting.value">
                    <v-icon color="red">mdi-alert</v-icon>
                  </template></v-select
                >
              </div>
            </div>
          </v-col>
        </v-row>
      </v-form>
      <v-card-actions v-if="!hasProducts">
        <v-btn
          rounded
          dark
          class="text-capitalize sigfloButtonSmall600 elevation-0 px-4"
          color="#7C40DC"
          @click="submitAndContinue"
          >Submit and continue<v-icon class="ml-2">mdi-arrow-right</v-icon></v-btn
        >
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
  import { mapState } from 'vuex';
  import sigHelpMenuButton from '@/components/shared/SigHelpMenuButton';

  export default {
    components: {
      sigHelpMenuButton
    },
    data() {
      return {};
    },
    created() {
      // handle navigation events
      this.$eventBus.$on('component-step-navigation', () => {
        if (this.hasSettings && this.$refs.settingsForm) {
          this.$refs.settingsForm.validate();
        }
      });
    },
    computed: {
      ...mapState(['configurator']),
      /**
       * Retrieves the Sigflo messages from the current subsystem step component's setting models.
       * @returns {Array} An array of objects containing the label and message of each Sigflo message.
       */
      sigfloMessages: function () {
        const messages = [];
        if (
          this.configurator.currentSubsystemStepComponent &&
          this.configurator.currentSubsystemStepComponent.componentSettingModels
        ) {
          this.configurator.currentSubsystemStepComponent.componentSettingModels.forEach((setting, i) => {
            if (setting.sigMessageModel) {
              const message = {
                id: i,
                label: setting.sigMessageModel.messageTitle,
                message: setting.sigMessageModel.message
              };
              messages.push(message);
            }
          });
        }
        return messages;
      }
    },
    methods: {
      isFieldValid(value, rules) {
        if (!rules) return true;
        return rules.every((rule) => {
          console.log(typeof rule);
          if (typeof rule === 'function') return rule(value) === true;
        });
      },
      /**
       * Returns an array of validation rules for a numeric setting.
       *
       * @param {Object} setting - The setting object.
       * @returns {Array} An array of validation rules.
       */
      getNumericRules(setting) {
        let rules = this.validation.numeric;
        if (setting.required) rules = rules.concat(this.validation.required);
        if (setting.minimumValue != null && setting.value)
          rules = rules.concat(this.validation.quantityRules.min(Number(setting.value), setting.minimumValue));
        if (setting.maximumValue != null && setting.value)
          rules = rules.concat(this.validation.quantityRules.max(Number(setting.value), setting.maximumValue));
        return rules;
      },
      /**
       * Submits the form and continues to the next step.
       *
       * This method validates the settings form using the `$refs.settingsForm.validate()` function
       * and then calls the `saveAndGoToStep()` method to save the current settings and navigate to the next step.
       */
      submitAndContinue() {
        this.$refs.settingsForm.validate();
        this.saveAndGoToStep(this.getCurrentStepIndex() + 1);
      },
      /**
       * Builds the dropdown list objects for specified setting
       */
      getComponentSettingValueModels: function (setting) {
        var items = [...setting.componentSettingValueModels];
        return items;
      },
      /**
       * Updates the component setting model with the new value and selected record.
       * If the new value is an array, it is converted to a delimited string.
       * The updated component setting model is committed to the Vuex store.
       * If the selected record's control type is 'dropdownlist' and the current subsystem step's product type ID is a number,
       * the current step is refreshed by calling the 'saveAndGoToStep' method.
       *
       * @param {any} newValue - The new value to update the component setting model with.
       * @param {object} selectedRecord - The selected record to update the component setting model with.
       * @returns {void}
       */
      updateComponentSettingModel: function (fieldRef, newValue, selectedRecord) {
        // validate input
        const field = this.$refs[fieldRef];
        const fieldComponent = field && Array.isArray(field) && field.length > 0 ? field[0] : field;
        const isValid = fieldComponent.validate();
        if (!isValid) return;

        if (Array.isArray(newValue)) newValue = newValue.join(',');

        // if newValue is not a boolean, convert it to a string
        if (typeof newValue !== 'boolean') {
          newValue = newValue.toString();
        }

        this.$store.commit('configurator/updateComponentSettingModel', {
          componentIndex: this.getCurrentStepIndex(),
          updatedComponentSettingModel: selectedRecord,
          newValue: newValue == null ? null : newValue
        });

        if (!isNaN(this.configurator.currentSubsystemStepComponent.productTypeId)) {
          //this.saveAndGoToStep(this.getCurrentStepIndex());
          this.saveSubsystemStepProgress('subsystem');
        }
      }
    }
  };
</script>

<style scoped>
  .requiredAsterisk {
    color: red;
    font-size: 1.2em;
    display: inline-block;
  }
  .helpButton {
    position: absolute;
    top: 25px;
    right: 35px;
  }
  .settingLabel {
    /* max-width: 200px; */
  }
  .settingColumn {
    min-width: 350px;
  }
  .settingInput {
    max-width: 350px;
  }
</style>
